<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Td7Py6/tc-custom/9781982156732.jpg?1737196002713" alt="This image is the cover for the book Shimmering State"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shimmering State
      </h1>
      <p class="bookDescription body article font2">
        <b>Named a Book You Need to Read in 2021 by <i>Harper’s Bazaar </i></b><br/><br/><b>A “moving, astounding, and totally unsettling” (Caroline Leavitt, </b><i><b>New York Times</b></i><b> bestselling author) literary debut following two patients in recovery after an experimental memory drug warps their lives.</b><br/><br/>Lucien moves to Los Angeles to be with his grandmother as she undergoes an experimental treatment for Alzheimer’s using the new drug, Memoroxin. An emerging photographer, he’s also running from the sudden death of his mother, a well-known artist whose legacy haunts him. <br/><br/>Sophie has just landed the lead in the upcoming performance of <i>La Sylphide</i> with the Los Angeles Ballet Company. She still waitresses at the Chateau Marmont during her off hours, witnessing the recreational use of Memoroxin—or Mem—among the Hollywood elite. <br/><br/>When Lucien and Sophie meet at The Center, founded by an ambitious yet conflicted doctor to treat patients who’ve abused Mem, they have no memory of how they got there—or why they feel so inexplicably drawn to each other. Is it attraction, or something they cannot remember from “before”? <br/><br/>“Contemplative and wonderfully evocative, finishing <i>The Shimmering State</i> is like waking from a dream, where you reenter the world with fresh eyes and wonder at the frailty of your own memories” (Jessica Chiarella, author of<i> The Lost Girls</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Meredith Westgate
      </h2>
      
      <p class="authorDescription body article">Meredith Westgate grew up in Lancaster, Pennsylvania, and now lives in Brooklyn, New York. She is a graduate of Dartmouth College and holds an MFA in fiction from The New School.&#160;<I>The Shimmering State&#160;</I>is her first novel. Visit her at MeredithWestgate.com and on Instagram @MeredithWestgate.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atria
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5dd1a364